import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { BaseService } from "@services/base.service";
import {
  LatePaymentInterestType,
  PaymentMethodType,
  PaymentTermsType,
} from "@shared/e-invoice";
import { EnumService } from "@services/common";
import { LabelValueModel } from "@shared/models/common/label-value.model";
import { AppConsts } from "@shared/app-consts";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class EInvoicePreferenceService extends BaseService {
  constructor(private http: HttpClient) {
    super();
  }

  getPaymentTermsName = (type: PaymentTermsType): string => {
    switch (type) {
      case PaymentTermsType.OnReception:
        return "À réception";
      case PaymentTermsType.EndOfMonth:
        return "Fin de mois";
      case PaymentTermsType.Days10:
        return "10 jours";
      case PaymentTermsType.Days30:
        return "30 jours";
      case PaymentTermsType.Days30AfterMonthEnd:
        return "30 jours après la fin de mois";
      case PaymentTermsType.Days45:
        return "45 jours";
      case PaymentTermsType.Days45AfterMonthEnd:
        return "45 jours après la fin de mois";
      case PaymentTermsType.Days60:
        return "60 jours";
      case PaymentTermsType.Days60AfterMonthEnd:
        return "60 jours après la fin de mois";
      case PaymentTermsType.Days90:
        return "90 jours";
      case PaymentTermsType.Days90AfterMonthEnd:
        return "90 jours après la fin de mois";
      case PaymentTermsType.Days120:
        return "120 jours";
      case PaymentTermsType.Other:
        return "Autre";
      default:
        return "";
    }
  };

  getPaymentMethodName = (type: PaymentMethodType): string => {
    switch (type) {
      case PaymentMethodType.None:
        return "Non spécifié";
      case PaymentMethodType.Payout:
        return "Virement Hors SEPA";
      case PaymentMethodType.PayoutSepa:
        return "Virement SEPA";
      case PaymentMethodType.Check:
        return "Chèque";
      case PaymentMethodType.Cash:
        return "Espèces";
      case PaymentMethodType.PaymentCard:
        return "Carte bancaire";
      default:
        return "";
    }
  };

  getLatePaymentInterest = (type: LatePaymentInterestType): string => {
    switch (type) {
      case LatePaymentInterestType.None:
        return "Pas d'intérêts de retard";
      case LatePaymentInterestType.MonthPercent1:
        return "1% par mois";
      case LatePaymentInterestType.MonthPercent1_5:
        return "1.5% par mois";
      case LatePaymentInterestType.MonthPercent2:
        return "2% par mois";
      case LatePaymentInterestType.Custom:
        return "À préciser";
      default:
        return "";
    }
  };

  getPaymentTermsOptions(): LabelValueModel[] {
    return EnumService.getNames(PaymentTermsType).map((key) => {
      const item = PaymentTermsType[key];
      const itemLabel = this.getPaymentTermsName(item);

      return new LabelValueModel(itemLabel, key);
    });
  }

  getPaymentMethodOptions(): LabelValueModel[] {
    return EnumService.getNames(PaymentMethodType).map((key) => {
      const item = PaymentMethodType[key];
      const itemLabel = this.getPaymentMethodName(item);

      return new LabelValueModel(itemLabel, key);
    });
  }

  getLatePaymentInterestOptions(): LabelValueModel[] {
    return EnumService.getNames(LatePaymentInterestType).map((key) => {
      const item = LatePaymentInterestType[key];
      const itemLabel = this.getLatePaymentInterest(item);

      return new LabelValueModel(itemLabel, key);
    });
  }
}
